import MgtvApi from 'MgtvApi';
import Env from './env';
import { dateFormater } from './date';


const ERROR_API = 'http://mlog.da.mgtv.com/info.php';

export function toQueryString(obj) {
  if (obj) {
    const data = Object.keys(obj).map((key) => {
      const value = obj[key];
      let originText = '';
      if (value != null) {
        if (value instanceof Object) {
          originText = JSON.stringify(value);
        } else {
          originText = value;
        }
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(originText)}`;
    });
    return data.join('&');
  }
  return '';
}


export function getPlatForm() {
  const arr = [];
  Object.keys(Env).forEach((key) => {
    if (Env[key]) {
      arr.push(key);
    }
  });
  const val = arr.filter(f => f);
  if (val.length) {
    return val.join('_').replace(/is/g, '').toLowerCase();
  }
  return 'shop';
}


export function getDeviceInfo() {
  return new Promise((resolve) => {
    if (Env.isMgtvApp) {
      MgtvApi.getDeviceInfo((data) => {
        resolve(JSON.parse(data));
      });
      setTimeout(() => {
        resolve({});
      }, 150);
    } else {
      resolve({});
    }
  });
}

export function getUserUUIDInfo() {
  return new Promise((resolve) => {
    if (Env.isMgtvApp) {
      MgtvApi.getUserInfo((data) => {
        resolve(JSON.parse(data));
      });
      setTimeout(() => {
        resolve({});
      }, 150);
    } else {
      resolve({});
    }
  });
}

export function getTime() {
  return dateFormater(new Date().getTime(), 'yyyyMMddhhmmss');
}

export async function sendError(err_msg) {
  const info = await getDeviceInfo();
  const data = {
    platform: getPlatForm(),
    err_type: 'js_error',
    err_msg: `${err_msg}`,
    f: -1,
    h: window.location.host,
    url: window.location.href,
    m: info.mac || '',
    did: info.imei || info.idfa || '',
    net: info.net || '',
    v: info.appVersion || '',
    s: 'shop',
    z: 'shop',
    t: 'shop',
    time: getTime(),
  };
  if (Env.isLocal) {
    console.log(data);
    return;
  }
  const url = `${ERROR_API}?${toQueryString(data)}`;
  const img = new Image();
  img.src = url;
}

// 主要用于监控接口异常  因为mgtv-monitor里的 window.onerror无效  js错误异常会被vue捕获 所以onerror无效
export async function initMonitorError() {
  const info = await getDeviceInfo;
  window.monitorConf = {
    platform: getPlatForm(),
    err_type: 'api_error',
    api: ERROR_API,
    f: -1,
    h: window.location.host,
    url: window.location.href,
    m: info.mac || '',
    did: info.imei || info.idfa || '',
    net: info.net || '',
    v: info.appVersion || '',
    s: 'shop',
    z: 'shop',
    t: 'shop',
    time: getTime(),
  };
}
